import { useBlockProps } from '@wordpress/block-editor';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#save
 *
 * @return {WPElement} Element to render.
 */
export default function save( props ) {
	const {
        url,
		width,
		height
    } = props.attributes;

	return (
		<div { ...useBlockProps.save() }>
			<div
			className="fb-page"
			data-href={ url }
			data-tabs="timeline"
			data-width={ width }
			data-height={ height }
			data-small-header="false"
			data-adapt-container-width="true"
			data-hide-cover="false"
			data-show-facepile="true"
			></div>
		</div>
	);
}
